export default {
  locus_list: { id: 'locus_list' },
  create_locus: { id: 'create_locus' },
  delete_locus: { id: 'delete_locus' },
  delete_locus_message: { id: 'delete_locus_message' },
  name: { id: 'name' },
  email: { id: 'email' },
  date_updated: { id: 'date_updated' },
  site: { id: 'site' },
  locusGroup: { id: 'locus_group' },
  editUnitData: { id: 'edit_unit_data' },
  removeUnit: { id: 'remove_unit' },
  active: { id: 'active' },
  visible: { id: 'visible' },
  visibleInUi: { id: 'visible_in_ui' },
  saveInfo: { id: 'save_info' },
  locusInfo: { id: 'locus_info' },
  createButton: { id: 'create_button' },
}
